import CreateTokenButton from './CreateTokenButton';

export default function TokenSubmitSection({
  note,
  isConnected,
  walletAddress,
  totalFeesText,
  validationError,
  mintError,
  success,
  isSubmitting,
  isConnecting,
  isPolling,
  onPrimaryAction,
  onCancelMint,
  isCancellingMint = false,
  vanityEnabled,
  progress,
  durationMs,
  statusMessage,
}) {
  return (
    <div className="pt-4 sm:pt-5 border-t border-white/5 mt-1">
      {note ? (
        <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-xs text-amber-100">
          {note}
        </div>
      ) : null}
      <p className="mt-2 text-xs text-gray-400 text-center">
        {isConnected ? `Connected: ${walletAddress?.slice(0, 6)}...${walletAddress?.slice(-4)}` : ''}
      </p>
      <p className="mt-3 text-sm text-gray-300 text-center">
        Total Fees: <span className="font-semibold text-cyan-300">{totalFeesText}</span>
      </p>
      <div className="mt-3 space-y-3">
        {validationError ? (
          <div className="rounded-xl border border-red-500/40 bg-red-900/30 px-4 py-3 text-sm text-red-100">
            <strong>Validation Error:</strong> {validationError}
          </div>
        ) : null}
        {mintError ? (
          <div className="rounded-xl border border-red-500/40 bg-red-900/30 px-4 py-3 text-sm text-red-100">
            <strong>Mint Error:</strong> {mintError}
          </div>
        ) : null}
        {success ? (
          <div className="rounded-xl border border-green-500/40 bg-green-900/30 px-4 py-3 text-sm text-green-100">
            {success}
          </div>
        ) : null}

        <CreateTokenButton
          disabled={isSubmitting || isConnecting || isPolling}
          onClick={onPrimaryAction}
          isConnected={isConnected}
          isPolling={isPolling}
          isSubmitting={isSubmitting}
          isConnecting={isConnecting}
          vanityEnabled={vanityEnabled}
          progress={progress}
          durationMs={durationMs}
          statusMessage={statusMessage}
        />
        {isPolling && typeof onCancelMint === "function" ? (
          <button
            type="button"
            onClick={onCancelMint}
            disabled={isCancellingMint}
            className="w-full rounded-xl border border-red-500/40 bg-red-950/40 px-4 py-3 text-sm font-medium text-red-100 transition hover:border-red-400/60 hover:bg-red-950/60 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isCancellingMint ? "Cancelling…" : "Cancel mint process"}
          </button>
        ) : null}
      </div>
    </div>
  );
}
